import { W as WuiButton$1, d as defineCustomElement$1 } from './p-BedvZv52.js';

const WuiButton = WuiButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiButton, defineCustomElement };
